import{Overlay as e}from"@mantine/core";import{jsx as p}from"@emotion/react/jsx-runtime";function a(r){return p(e,{...r})}var o=a;export{o as Overlay};
